import React from "react";
import { iconProps } from "../../Helper";

const LeftScrollIcon = ({className}:iconProps) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
      className={className}
        d="M13.4297 13.75L8.60269 7L13.4297 0.25H11.5952L6.76819 7L11.5952 13.75H13.4297ZM7.55669 13.75L2.72969 7L7.55669 0.25H5.72194L0.895187 7L5.72194 13.75H7.55669Z"
        fill="white"
      />
    </svg>
  );
};

export default LeftScrollIcon;
